import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import type { ColumnsType } from "@similarweb/pro-logic-components";

import { useTranslation } from "pro-features/components/WithTranslation";

import { BenchmarkGranularity } from "../../../../../services/api/constants";
import type { BenchmarkUrlParams } from "../../../../../types/paramsTypes";
import { type ICommonData, type IDomainData, useCommonColumnsConfig } from "../../../hooks/useCommonColumnsConfig";
import { type IShareColumnData, useShareColumnConfig } from "../hooks/useShareColumnConfig";

export type Data = ICommonData & IShareColumnData & IDomainData;

export const useColumnsConfig = () => {
    const translate = useTranslation();
    const { highlightedDomainColumn, popColumn, rankColumn, trendColumn, yoyColumn } = useCommonColumnsConfig();
    const shareColumn = useShareColumnConfig();
    const {
        params: { granularity },
    } = useCurrentStateAndParams<BenchmarkUrlParams>();

    return useMemo(
        () =>
            [
                rankColumn,
                highlightedDomainColumn,
                {
                    ...shareColumn,
                    title: translate("common.tables.columns.traffic.share.title"),
                },
                {
                    ...trendColumn,
                    width: 100,
                    minWidth: 100,
                },
                {
                    ...popColumn,
                    title: translate(granularity === BenchmarkGranularity.MONTHLY ? "common.mom" : "common.wow"),
                    width: 100,
                    minWidth: 100,
                },
                {
                    ...yoyColumn,
                    title: translate("common.yoy"),
                    width: 100,
                    minWidth: 100,
                },
            ] satisfies ColumnsType<Data>,
        [translate, granularity, highlightedDomainColumn, popColumn, rankColumn, shareColumn, trendColumn, yoyColumn],
    );
};
